export const MCP_USER_SELECTION_KEY = 'mcp-user-entitlements';
export const MCP_ACCOUNT_SELECTION_KEY = 'mcp-account-entitlements';

export const USER_SECTION_NAME = 'Custom User MCP Entitlements';
export const ACCOUNT_SECTION_NAME = 'Account MCP Entitlements';

export const NO_ASSIGNED_USER_MCP_ENTITLEMENT_DESCRIPTION =
    'No custom MCP entitlements assigned.';

export const NO_ASSIGNED_ACCOUNT_MCP_ENTITLEMENT_DESCRIPTION =
    'No MCP entitlements assigned to parent account.';
